import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { of, switchMap, take } from 'rxjs';

import { WcgTableUtilsService } from '@shared/services/wcg-table-utils.service';
import { SitesDetailFacadeService } from '@shared/services/sites-detail-facade.service';

import { organizationFacilitiesTokenizer } from '../store';
import { FacilitiesGridTypes, LoadGridPayload } from '../types';
import {CONFIGURE_DEFAULT_PARAMS} from '../constants';


export const facilitiesResolver = (route: ActivatedRouteSnapshot) => {
  const _facilitiesSignalStore = organizationFacilitiesTokenizer();
  const _wcgTableUtils = inject(WcgTableUtilsService);

  const _params = _wcgTableUtils.generateTableQueryParams(
    CONFIGURE_DEFAULT_PARAMS(route),
  );

  const gridType: FacilitiesGridTypes = route.data.type ?? 'main';

  const loadGrid = (id: string) => {
    const payload: LoadGridPayload = { params: _params };

    _facilitiesSignalStore.setByURL(gridType, id);
    _facilitiesSignalStore.loadFacilitiesGrid(payload);

    return of(true);
  };

  if (gridType === 'site') {
    const siteId = route.paramMap.get('siteId') ?? '';
    if (!siteId) {
      console.error('facilitiesResolver: Missing siteId in route params');
      return of(null);
    }
    const siteFacade = inject(SitesDetailFacadeService);

    return siteFacade.loadSiteDetailFn(siteId).pipe(
      take(1),
      switchMap((siteDetails) => loadGrid(siteDetails?.id ?? '')),
    );
  }

  return loadGrid(route.paramMap.get('id') ?? '');
};
